import { render, staticRenderFns } from "./social-view.vue?vue&type=template&id=cb2e8642&scoped=true&lang=pug"
import script from "./social-view.js?vue&type=script&lang=js&external"
export * from "./social-view.js?vue&type=script&lang=js&external"
import style0 from "./social-view.vue?vue&type=style&index=0&id=cb2e8642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2e8642",
  null
  
)

export default component.exports